import React, { useEffect } from 'react';
import { FlatList, HStack, VStack, Skeleton } from 'native-base';
import { BrandsCard } from './BrandsCard';
import { Brand, ProductListPageProps, useBrandsByRetailerIdQuery, useDutchieStore, useI18n } from '@springbig/shared';
import { useShopStyles } from '~/shared/styles';
import { Caption } from '~/shared/Typography';
import { useAppNavigate } from '~/pages';

export const BrandsList = () => {

    const { primary_color, section_background } = useShopStyles();
    const { mutate: getBrands, data, isLoading } = useBrandsByRetailerIdQuery();
    const { retailer, menuType, setProductListProps } = useDutchieStore();
    const { navigate, params } = useAppNavigate();
    const { t } = useI18n();

    useEffect(() => {

        if (retailer && menuType && !data && !isLoading) {
            const variables = {
                'retailerId': retailer.id,
                menuType,
            };
            getBrands(variables);
        }
    }, [retailer, menuType, getBrands]);

    return (
        !isLoading ?
            <VStack ml={2}>
                <HStack space={2}>
                    <Caption>
                        { t('shop.favorite_brands') }
                    </Caption>
                </HStack>
                <FlatList
                    horizontal={true}
                    data={data?.menu?.brands}
                    renderItem={({ item, index } : { item: Brand, index: number }) =>

                        <BrandsCard brand={item} onSelectBrand={() => {

                            const productListProps: ProductListPageProps = {
                                brand: item
                            };
                            setProductListProps(productListProps);
                            navigate(`w/${params.wallet_id}/shop/product_list`);
                        }} key={index} />
                    }
                />
            </VStack>
            :
            <VStack px={2}>
                <Skeleton
                    w={120}
                    h={6}
                    rounded={'xl'}
                    startColor={primary_color}
                    endColor={section_background}
                />
                <HStack space={4} mt={4} ml={3}>
                    { [...Array(4)].map((_, index) =>

                        <Skeleton
                            key={index}
                            size={'100px'}
                            rounded={'full'}
                            startColor={primary_color}
                            endColor={section_background}
                        />
                    )}
                </HStack>
            </VStack>
    );
};
